import { render } from "./AddAccount.vue?vue&type=template&id=033bdb27&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"

import "./AddAccount.vue?vue&type=style&index=0&id=033bdb27&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033bdb27"]])

export default __exports__